import { render, staticRenderFns } from "./DeleteNode.vue?vue&type=template&id=0246b6f9&scoped=true&"
import script from "./DeleteNode.vue?vue&type=script&lang=js&"
export * from "./DeleteNode.vue?vue&type=script&lang=js&"
import style0 from "./DeleteNode.vue?vue&type=style&index=0&id=0246b6f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0246b6f9",
  null
  
)

export default component.exports